import {transformSelectOptions} from "@/util/ComponentUtils";
import {
    MonthsEnum,
    YesNoEnum,
    WsOrFtpsEnum,
    TyposKatalogouEnum,
    ApotelesmaParalavisEnum,
    TyposApostolisEnum,
    ProgTaskEnum,
    EidosDhloshsEnum, EpopthsEnum, KathgoriaEnum,
    XopiDocType
} from "@/util/EnumUtil";
import {isEmpty} from "@/util/Helpers";

const getDefaultState = () => {
    return {
        dhmos: [],
        nomikhMorfh: [],
        bathmos: [],
        dpkOria: [],
        idiothta: [],
        protException: [],
        epopForeaByYear: [],
        allParentIdiothtes: [],
        allDetailIdiothtes: [],
        detailsThirdLayer: [],
        aitiaApoleias: [],
        allLaw: [],
        inspectionOrgs: [],
        parametric: {
            staticList: {...(XopiDocType),...(YesNoEnum), ...(MonthsEnum), ...(WsOrFtpsEnum), ...(TyposKatalogouEnum), ...(ApotelesmaParalavisEnum), ...(TyposApostolisEnum), ...(ProgTaskEnum), ...(EidosDhloshsEnum), ...(EpopthsEnum), ...(KathgoriaEnum)}
        }
    }
}
export const namespaced = true
export const state = getDefaultState()

export const mutations = {

    SET_LOOKUPS(state, data) {
        state.doy = data.doy
        state.dhmos = data.dhmos
        state.dpkOria = data.dpkOria
        state.nomikhMorfh = data.nomikhMorfh
        state.bathmos = data.bathmos
        state.idiothta = data.idiothta
        state.aitiaApoleias = data.aitiaApoleias
    },
    SET_PROT_EXCEPTION(state, data) {
        state.protException = data
    },
    SET_EPOP_FOREA_BY_YEAR(state, data) {
        state.epopForeaByYear = data
    },
    SET_ALL_PARENT_IDIOTHTES(state, data) {
        state.allParentIdiothtes = data
    },
    SET_ALL_DETAIL_IDIOTHTES(state, data) {
        state.allDetailIdiothtes = data
    },
    SET_ALL_LAW(state, data) {
        state.allLaw = data
    },
    SET_ALL_INSPECTION_ORGS(state, data) {
        state.inspectionOrgs = data
    },
    SET_PARAMETRICS(state) {
        state.parametric.staticList = {...(XopiDocType),...(YesNoEnum), ...(MonthsEnum), ...(WsOrFtpsEnum), ...(TyposKatalogouEnum), ...(ApotelesmaParalavisEnum), ...(TyposApostolisEnum), ...(ProgTaskEnum), ...(EidosDhloshsEnum), ...(EpopthsEnum), ...(KathgoriaEnum)}
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}
export const actions = {
    setProtException({commit}, data) {
        commit('SET_PROT_EXCEPTION', data)
    },
    setEpopForeaByYear({commit}, data) {
        commit('SET_EPOP_FOREA_BY_YEAR', data)
    },
    setAllParentIdiothtes({commit}, data) {
        commit('SET_ALL_PARENT_IDIOTHTES', data)
    },
    setAllDetailIdiothtes({commit}, data) {
        commit('SET_ALL_DETAIL_IDIOTHTES', data)
    },
    setAllLaw({commit}, data) {
        commit('SET_ALL_LAW', data)
    },
    setAllInspectionOrgs({commit}, data) {
        commit('SET_ALL_INSPECTION_ORGS', data)
    },
    setLookups({commit}, data) {
        commit('SET_LOOKUPS', data)
    },
    resetState({commit}) {
        commit('RESET_STATE')
    },
    setParametrics({commit}, data) {
        commit('SET_PARAMETRICS', data)
    }
}

export const getters = {
    getDhmos: (state) => {
        let data = transformSelectOptions(state.dhmos, 'dhmos', "")
        data.forEach(row => {
            if (!isEmpty(row.value)) {
                delete row.value.nomosT033
            }
        })
        return data
    },
    getNomikhMorfh: (state) => transformSelectOptions(state.nomikhMorfh, 'morfh', ""),
    getYesNo: (state) => state.parametric.staticList.yesNo,
    getMonths: (state) => state.parametric.staticList.months,
    getWsOrFtps: (state) => state.parametric.staticList.wsOrFtps,
    getTyposKatalogou: (state) => state.parametric.staticList.typosKatalogou,
    getApotelesmaParalavis: (state) => state.parametric.staticList.apotelesmaParalavis,
    getTyposApostolis: (state) => state.parametric.staticList.typosApostolis,
    getProgTask: (state) => state.parametric.staticList.progTask,
    getEidosDhloshs: (state) => state.parametric.staticList.eidosDhloshs,
    getEpopths: (state) => state.parametric.staticList.epopths,
    getKathgoria: (state) => state.parametric.staticList.kathgoria,
    getOria: (state) => state.dpkOria,
    getProtException: (state) => transformSelectOptions(state.protException, 'name', ""),
    getAllInspectionOrgs: (state) => transformSelectOptions(state.inspectionOrgs, 'onoma', ""),
    getAllParentIdiothtes: (state) => transformSelectOptions(state.allParentIdiothtes, 'idiothtaDecr', ""),
    getAllDetaildiothtes: (state) => transformSelectOptions(state.allDetailIdiothtes, 'idiothtaDecr', ""),
    getAllLaw: (state) => transformSelectOptions(state.allLaw, 'description', ""),
    getBathmos: (state) => transformSelectOptions(state.bathmos, 'bathmosDecr', ""),
    getIdiothta: (state) => transformSelectOptions(state.idiothta, 'idiothtaDecr', ""),
    getAitiaApoleias: (state) => transformSelectOptions(state.aitiaApoleias, 'aitiaApoleias', ""),
    getXopiDocType: (state) => state.parametric.staticList.xopiDocType,
}

